import { useCallback, useEffect, useState } from "react";
import { DecisionTree } from "../../types/api/decision-tree";
import { get, set } from "idb-keyval";
import api from "../../utils/api/axios";
import { AxiosError } from "axios";
import { setHasNoNetwork } from "../../store/reducers/auth.slice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import "./DecisionTree.css";
import { StyledCircularProgress } from "../../components/Loader";
import TreeSelect from "../../components/decision-tree/TreeSelect";
import { useNavigate } from "react-router-dom";

const DecisionTreeSelect = () => {
  const navigate = useNavigate();
  const [decisionTreeList, setDecisionTreeList] = useState<DecisionTree[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const auth = useAppSelector((state) => state.auth);
  const { hasNoNetwork } = auth;
  const dispatch = useAppDispatch();

  const fetchDataOffline = useCallback(async () => {
    const decisionTrees = await get<DecisionTree[]>("decision-trees");
    if (!decisionTrees) return false;
    setDecisionTreeList(decisionTrees);
    return true;
  }, []);

  const saveDecisionTrees = async (decisionTrees: DecisionTree[]) => {
    await set("decision-trees", decisionTrees);
  };

  const fetchDataOnline = useCallback(async () => {
    const { data } = await api.get<DecisionTree[]>(`/decision-trees/list`);

    setDecisionTreeList(data.sort((a, b) => a.name.localeCompare(b.name)));
    saveDecisionTrees(data);
  }, []);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    const offlineSuccess = await fetchDataOffline();
    if (offlineSuccess) {
      setIsLoading(false);
    }
    try {
      await fetchDataOnline();
    } catch (e) {
      if (e instanceof AxiosError) {
        if (e.status === 500) dispatch(setHasNoNetwork(true));
      }
    }
    setIsLoading(false);
  }, [dispatch, fetchDataOffline, fetchDataOnline]);

  useEffect(() => {
    fetchData();
  }, [fetchData, hasNoNetwork]);

  return (
    <div className="decison-tree-container">
      <h1 className="decision-tree-title">
        Aide à la prescription des antibiotiques
      </h1>
      {isLoading ? (
        <StyledCircularProgress size={24} />
      ) : (
        <div className="decision-tree-select-container">
          <p className="decision-tree-select-text">
            Sélectionner une infection dans la liste ci-dessous pour accéder à
            l'antibiothérapie appropriée
          </p>
          <TreeSelect
            decisionTreeList={decisionTreeList}
            onSelectDecisionTree={(tree) => {
              navigate(`/aide-administration/${tree.id}`);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DecisionTreeSelect;
